/**
 * @generated SignedSource<<96d167c998068b1e8321669191822287>>
 * @relayHash 9c2194bc34b136960b18b5b8287d244b
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9c2194bc34b136960b18b5b8287d244b

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DestroyPartInput = {
  clientMutationId?: string | null;
  partId: string;
};
export type PartDestroyMutation$variables = {
  input: DestroyPartInput;
};
export type PartDestroyMutation$data = {
  readonly destroyPart: {
    readonly question: {
      readonly id: string;
      readonly parts: ReadonlyArray<{
        readonly id: string;
        readonly index: number;
      }>;
    };
  } | null;
};
export type PartDestroyMutation = {
  response: PartDestroyMutation$data;
  variables: PartDestroyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DestroyPartPayload",
    "kind": "LinkedField",
    "name": "destroyPart",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Question",
        "kind": "LinkedField",
        "name": "question",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Part",
            "kind": "LinkedField",
            "name": "parts",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "index",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PartDestroyMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PartDestroyMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "9c2194bc34b136960b18b5b8287d244b",
    "metadata": {},
    "name": "PartDestroyMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "a6d6e2487a98bae1baf76386a575d0e6";

export default node;
